import { render } from "./ContactCardOnboarding.vue?vue&type=template&id=603a720d"
import script from "./ContactCardOnboarding.vue?vue&type=script&lang=js"
export * from "./ContactCardOnboarding.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__